import { render, staticRenderFns } from "./ReorderMainSkills.vue?vue&type=template&id=b46cd41a"
import script from "./ReorderMainSkills.vue?vue&type=script&lang=js"
export * from "./ReorderMainSkills.vue?vue&type=script&lang=js"
import style0 from "./ReorderMainSkills.vue?vue&type=style&index=0&id=b46cd41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReorderMainSkills.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports